import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { LOGIN_PAGES } from '../enum-login-pages';
import { MixpanelService } from '../../../services/mixpanel-service/mixpanel.service';

@Component({
  selector: 'app-account-confirmed',
  templateUrl: './account-confirmed.component.html',
  styleUrls: ['./account-confirmed.component.scss'],
})
export class AccountConfirmedComponent implements OnInit {
  @Output() nextStep = new EventEmitter<number>();

  constructor(private mixpanelService: MixpanelService) {}

  ngOnInit(): void {}

  backToLogin() {
    const userEmail = localStorage.getItem('userEmail') || '';
    this.mixpanelService.track({
      id: userEmail,
      eventName: 'back_to_sign_in_click',
      eventDisplayName: 'back_to Sign In Button Click',
      kpi: 'Click-Through Rate',
      trigger: 'On Button Click',
      eventDefinition: 'User clicks the back_to sign-in button',
      propertyType: 'Event Property',
      propertyDefinition: 'Button Label backToLogin',
    });
    this.nextStep.emit(LOGIN_PAGES.EMAIL);
  }
}
